import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useDataFetchIndicator } from '..';

import vopayApi from '@/services/api.config';

type HookProps = { api: vp.Api; bearer?: string };

type HookTuple = [
  response: vp.EftFundingTransactionResponse,
  fetchData: (params: vp.TransactionRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchEFTFundTransaction: ApiHook = ({ api, bearer }: HookProps) => {
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.TransactionRequest>({
    TransactionID: '',
    Timezone: 'UTC',
  });
  const [response, setResponse] = useState<vp.EftFundingTransactionResponse>({
    ErrorMessage: '',
    Success: false,
    TransactionID: '',
    TransactionStatus: vp.TransactionStatus.BLANK,
    TransactionDateTime: '',
    HoldReleaseDateTime: '',
    Amount: '',
    Currency: 'CAD',
    HoldAmount: '',
    ScheduledTransactionID: '',
    FirstName: '',
    LastName: '',
    CompanyName: '',
    RecipientName: '',
    DOB: '',
    PhoneNumber: '',
    Email: '',
    Address1: '',
    Address2: '',
    City: '',
    Province: '',
    Country: '',
    PostalCode: '',
    FinancialInstitutionNumber: '',
    BranchTransitNumber: '',
    AccountNumber: '',
    ClientReferenceNumber: '',
    LastModified: '',
    ABARoutingNumber: '',
    IBAN: '',
    Iq11: '',
    KYCPerformed: '',
    KYCReferenceNumber: '',
    SortCode: '',
    ParentTransactionID: '',
    SubTransactions: [],
    FailureReason: '',
    GLCode: '',
    WireReferenceNumber: '',
    TransactionTypeCode: '',
  });

  const [shouldSendRequest, setSendRequest] = useState(false);

  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async () => {
      setDataFetchingInfo(true, 'loading transaction data', 'fullScreen', true);
      const res = await api.fetchEFTFundTransaction(params, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false, 'loading some data', 'fullScreen', false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest();

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (params: vp.TransactionRequest) => {
      setParams(params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        ErrorMessage: '',
        Success: false,
        TransactionID: '',
        TransactionStatus: vp.TransactionStatus.BLANK,
        TransactionDateTime: '',
        HoldReleaseDateTime: '',
        Amount: '',
        Currency: 'CAD',
        HoldAmount: '',
        ScheduledTransactionID: '',
        FirstName: '',
        LastName: '',
        CompanyName: '',
        RecipientName: '',
        DOB: '',
        PhoneNumber: '',
        Email: '',
        Address1: '',
        Address2: '',
        City: '',
        Province: '',
        Country: '',
        PostalCode: '',
        FinancialInstitutionNumber: '',
        BranchTransitNumber: '',
        AccountNumber: '',
        ClientReferenceNumber: '',
        LastModified: '',
        ABARoutingNumber: '',
        IBAN: '',
        Iq11: '',
        KYCPerformed: '',
        KYCReferenceNumber: '',
        SortCode: '',
        ParentTransactionID: '',
        SubTransactions: [],
        FailureReason: '',
        GLCode: '',
        WireReferenceNumber: '',
        TransactionTypeCode: '',
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchEFTFundTransaction);
